import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useSubscriptionCheck from '../../common/SubscriptionCheck';

function InvoiceListPageActions() {
  const navigate = useNavigate();
  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();

  const handleCreateAction = () => {
    if (!checkSubscription()) {
      return;
    }
    return navigate('/documents/invoices/create');
  };

  return (
    <>
      <Button
        id="create-invoice"
        key="create-new-invoice"
        variant="contained"
        color="primary"
        onClick={handleCreateAction}
      >
        + Create Invoice
      </Button>
      <SubscriptionModal />
    </>
  );
}

export default InvoiceListPageActions;
